export default __webpack_public_path__ + "img/clipboard-list.5d84269f.svg";